import { object, string, bool, ref, number, ValidationError } from "yup";

import { PASSWORD_MSG, PASSWORD_REGEX } from "utils/constants";

const initialValues = (email) => ({
  email: email || "",
  password: "",
  persist: false,
});

const validationSchema = object({
  email: string()
    .trim()
    .email("Invalid email address")
    .required("Email is required"),
  password: string().trim().required("Password is required"),
  persist: bool().required("Required"),
});

const signupInitialValues = {
  first_name: "",
  last_name: "",
  email: "",
  password: "",
  reTypePassword: "",
};

const newSignupInitialValues = {
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  password: "",
  confirm_password: "",
  captcha_value: "",
};

const stepSignupInitialValues = {
  email: "",
  password: "",
};

const step2SignupInitialValues = {
  first_name: "",
  last_name: "",
  phone: "",
};

const step3SignupInitialValues = {
  number1: "",
  number2: "",
  number3: "",
  number4: "",
  number5: "",
  number6: "",
};

const errors = [
  {
    key: "1spchar",
    verified: false,
    label: "Include a Special Character",
  },
  {
    key: "8char",
    verified: false,
    label: "At least 8 characters",
  },
  {
    key: "1num",
    verified: false,
    label: "Include a Number",
  },
  {
    key: "1upchar",
    verified: false,
    label: "Include an Uppercase Letter",
  },
];

export const PASSWORD_REQUIREMENTS_MSG =
  "Password does not meet the requirements";

export const passwordErrorTransform = (err) =>
  Array.isArray(err) ? PASSWORD_REQUIREMENTS_MSG : err;

export const passwordValidator = (value, field) => {
  errors.map((e) => (e.verified = false));

  if (value && value.length >= 8) {
    const idx = errors.findIndex((e) => e.key === "8char");
    errors[idx].verified = true;
  }

  if (/^(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])/.test(value)) {
    const idx = errors.findIndex((e) => e.key === "1spchar");
    errors[idx].verified = true;
  }

  if (/^(?=.*[A-Z])/.test(value)) {
    const idx = errors.findIndex((e) => e.key === "1upchar");
    errors[idx].verified = true;
  }

  if (/^(?=.*[0-9])/.test(value)) {
    const idx = errors.findIndex((e) => e.key === "1num");
    errors[idx].verified = true;
  }

  if (errors.filter((e) => !e.verified).length) {
    const snapshot = errors.map((e) => ({ ...e }));
    throw new ValidationError({
      errors: snapshot,
      inner: true,
      path: field.path,
      message: snapshot,
      value: value,
      name: "ValidationError",
    });
  }

  return true;
};

const newSignupValidationSchema = object({
  first_name: string()
    .trim()
    .required("First name is required")
    .max(50, "Must be 50 characters or less"),
  last_name: string()
    .trim()
    .required("Last name is required")
    .max(50, "Must be 50 characters or less"),
  captcha_value: string().trim().required("Captcha is required").max(10),
  email: string()
    .trim()
    .email("Invalid email address")
    .required("Email is required"),
  phone: string().trim().max(18, "Invalid Phone"),
  // phone: string().min(4, "Invalid Phone").max(18, "Invalid Phone"),
  password: string()
    .trim()
    .required("Password is required")
    // .matches(PASSWORD_REGEX, PASSWORD_MSG)
    .test({ test: passwordValidator }),
  confirm_password: string()
    .trim()
    .oneOf([ref("password"), null], "Passwords must match")
    .required("Please confirm your password"),
});

const stepSignupValidationSchema = object({
  email: string()
    .trim()
    .email("Invalid email address")
    .required("Email is required"),
  password: string()
    .trim()
    .required("Password is required")
    .matches(PASSWORD_REGEX, PASSWORD_MSG),
});

const step2SignupValidationSchema = object({
  first_name: string()
    .trim()
    .required("First name is required")
    .max(50, "Must be 50 characters or less"),
  last_name: string()
    .trim()
    .required("Last name is required")
    .max(50, "Must be 50 characters or less"),
  phone: string()
    .min(4, "Invalid Phone")
    .max(18, "Invalid Phone")
    .required("Phone is required"),
});

const fpInitialValues = {
  email: "",
};

const fpValidationSchema = object({
  email: string()
    .trim()
    .email("Invalid email address")
    .required("Email is required"),
});

const rpInitialValues = {
  password: "",
  confirmPassword: "",
};

const rpValidationSchema = object({
  password: string()
    .trim()
    .required("Password is required")
    .test({ test: passwordValidator }),
  confirmPassword: string()
    .trim()
    .required("Please confirm your password")
    .oneOf([ref("password"), null], "Passwords must match"),
});

const waitingListInitValues = {
  email: "",
};

const waitingListValidationSchema = object({
  email: string()
    .trim()
    .email("Invalid email address")
    .required("Email is required"),
});

const vpInitialValues = {
  code: "",
};

const vpValidationSchema = object({
  code: string()
    .trim()
    .required("Code is required")
    .max(6, "Must be 6 characters or less"),
});

const step3SignupValidationSchema = object({
  number1: number().required("Required"),
  number2: number().required("Required"),
  number3: number().required("Required"),
  number4: number().required("Required"),
  number5: number().required("Required"),
  number6: number().required("Required"),
});

export {
  initialValues,
  validationSchema,
  signupInitialValues,
  fpInitialValues,
  fpValidationSchema,
  rpInitialValues,
  rpValidationSchema,
  waitingListInitValues,
  waitingListValidationSchema,
  newSignupInitialValues,
  newSignupValidationSchema,
  vpInitialValues,
  vpValidationSchema,
  stepSignupInitialValues,
  stepSignupValidationSchema,
  step2SignupValidationSchema,
  step2SignupInitialValues,
  step3SignupInitialValues,
  step3SignupValidationSchema,
};
